import { ITraceable } from "./_traceable";

enum WayStock {
    InStock = 0, // + entrée en stock
    OutOfStock = 1, // - sortie de stock
    None = 2, // Les 2 + et -
}

enum MovementTypeVisibility {
    NotVisible = 0,
    VisibleSemence = 1,
    VisibleMateriel = 2,
    AllVisible = 3,
}

interface IMovementType extends ITraceable {
    name: string;
    description: string;
    way : WayStock;
    visibility: MovementTypeVisibility;
    visibleInHistory: boolean;
}

export { type IMovementType, WayStock, MovementTypeVisibility };
